import routes from "routes"
import Link from "next/link"
import { WorkItem } from "../../../models/WorkItem/WorkItem"
import TieupImg from "src/components/common/TieupImg"
import UserName from "src/components/pages/ranking/UserName"
import TimeUtil from "src/utils/TimeUtil"
import { SizeType } from "../../common/TieupImg/SizeType"

const Card: React.FC<{ item: WorkItem; rank: number }> = ({ item, rank }) => {
  const isNew =
    item.novel.published_at &&
    TimeUtil.isWithinDays(item.novel.published_at, 14)

  return (
    <article key={item.id} className="p-ranking-works-item">
      <div className="p-ranking-works-image">
        <Link href={routes.seriesDetail(item.novel_id.toString())}>
          <a className="p-ranking-works-image-anchor">
            <TieupImg
              src={item.novel.cover_template_image || "/img/cover.png"}
              size={SizeType.s}
            />
          </a>
        </Link>
      </div>
      <div className="p-ranking-works-detail">
        <div className="p-ranking-label">
          <div className={`p-ranking-label-rank --number${rank}`}>{rank}位</div>
          {isNew && <span className="p-ranking-label-new">NEW!</span>}
        </div>
        <h2 className="p-ranking-works-title">
          <Link href={routes.seriesDetail(item.novel_id.toString())}>
            <a className="p-ranking-works-title-anchor">{item.novel.title}</a>
          </Link>
        </h2>
        <UserName item={item} />
      </div>
    </article>
  )
}

export default Card
